import { RouteObject } from "react-router-dom";
import { CALENDAR_PATH, CalendarPage } from "./pages/calendar";

export const calendarRoutes: RouteObject[] = [
  {
    path: CALENDAR_PATH,
    element: <CalendarPage />,
  },
];
